module.exports = __webpack_public_path__ + "static/img/slivers.0ffb9d8f.png";